import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\PrimaryButton.tsx.esbuild-plugin-windicss.css';
import { cx } from '@linaria/core';
import { StyleType } from '../../doodle/view/StyleType';
import { Icon } from './Icon';
export const PrimaryButton = ({
  icon,
  label,
  disabled,
  className,
  style,
  onClick
}: {
  icon?: string;
  label: string;
  disabled?: boolean;
  className?: string;
  style?: StyleType;
  onClick: () => unknown;
}) => <button data-text={label} type="button" class={cx('mui-btn mui-btn--small mui-btn--raised mui-btn--primary inline-flex items-center justify-center', className)} disabled={disabled} style={style} onClick={onClick}>
    {!!icon && <Icon icon={icon} className="w-1.5em h-1.5em mr-0.5em" />}
    {label}
  </button>;